import { render, staticRenderFns } from "./ChannelDigitalList.vue?vue&type=template&id=10f7101a&scoped=true&"
import script from "./ChannelDigitalList.vue?vue&type=script&lang=js&"
export * from "./ChannelDigitalList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDigitalList.vue?vue&type=style&index=0&id=10f7101a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7101a",
  null
  
)

export default component.exports